import NavigationButtons from '@atpoint/atpjs/components/navigation_buttons'
import i18n from '@atpoint/atpjs/helpers/i18n'
import { ButtonsWrapper, StyledButton } from 'swisscard/components/buttons'

import type { NavigationButtonsPropsType } from '@atpoint/atpjs/components/navigation_buttons'
import type React from 'react'

class ExtendedNavigationButtons extends NavigationButtons {
  buttonNext() {
    const { tabIndex, nextAction, nextLabel, nextProps = {} } = this.props

    if (nextAction) {
      return (
        <StyledButton
          {...nextProps}
          hasTracking
          key="next"
          type="submit"
          next
          disabled={this.state.disabled || this.props.disabled}
          loading={this.state.loading || this.props.loading}
          tabIndex={tabIndex}
          primary
          onClick={this.clickHandlerNext}>
          {nextLabel || i18n.trans(['buttons', 'next'])}
        </StyledButton>
      )
    }

    return null
  }

  buttonPrevious() {
    const { tabIndex, previousAction, previousLabel, previousProps = {} } = this.props

    if (previousAction) {
      return (
        <StyledButton
          {...previousProps}
          hasTracking
          key="previous"
          type="button"
          back
          disabled={this.state.disabled || this.props.disabled}
          tabIndex={tabIndex}
          onClick={this.clickHandlerPrevious}>
          {previousLabel || i18n.trans(['buttons', 'previous'])}
        </StyledButton>
      )
    }

    return null
  }

  render() {
    const { children } = this.props
    return (
      <ButtonsWrapper>
        {this.buttons()}
        {children}
      </ButtonsWrapper>
    )
  }
}

export const StyledNavigationButtons: React.FC<NavigationButtonsPropsType> = (props: NavigationButtonsPropsType) => {
  const { tabIndex, nextAction, nextLabel, nextProps = {} } = props

  return (
    <ExtendedNavigationButtons
      {...props}
      tabIndex={tabIndex}
      nextAction={nextAction}
      nextLabel={nextLabel}
      nextProps={nextProps}
    />
  )
}
